module.exports = __webpack_public_path__ + "static/images/expired-order.h0omRR2.svg";